export const receiveContact = contact => {
  return {
    type: 'RECEIVE_CONTACT',
    contact
  }
}